import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {X5LessonStore} from '../X5LessonStore';

@observer
export class UpdateSnapshotControls extends React.Component<{ store: X5LessonStore }> {
  render() {
    const {store} = this.props;

    if (store.updateSnapshot === null)
      return null;

    const updateSnapshot = store.updateSnapshot;
    const version = updateSnapshot.version;
    const isPending = updateSnapshot.save?.isPending === true;

    return (<>
      <div className="row">
        <div className="col-md-4 col-xs-6">
          <div className={version.formGroupClassName}>
            <label>Version</label>
            <input type="text" className="form-control"
                   value={version.value}
                   onChange={version.onChangeHandler}
                   onBlur={version.markTouched}
                   onKeyDown={store.completeOnEnter}/>
            <div className="invalid-text">Enter version</div>
          </div>
        </div>
        <div className="col-auto ml-auto">
          <button type="button" className="btn btn-primary"
                  onClick={store.completeUpdateSnapshot}
                  disabled={isPending}> Save
          </button>
          <button type="button" className="btn btn-primary"
                  onClick={store.cancel}
                  disabled={isPending}> Cancel
          </button>
        </div>
      </div>

      <PromiseMessage label="Saving" state={updateSnapshot.save} align="right"/>
    </>);
  }
}
